<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>Oil Beach</h1>
<h1 class="bk1">How Toxic Infrastructure Threatens Life in the Ports of Los Angeles and Beyond</h1>
<p class="bkau">Christina Dunbar-Hester</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm"></span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-dunbar-hester-0003.vue?d63146a8